import "./Popup.scss"

import React from "react"

import { popupApi } from "@shared/apis"
import { Popup as PopupType } from "@shared/apis/popup"
import { setIsPopupClosed } from "@shared/modules"

interface Props {
  popup: PopupType
  handlePopup(newPopup: PopupType): void
}

export default function Popup({ popup, handlePopup }: Props) {
  function renderContent(_popup: PopupType) {
    switch (_popup.contentsType) {
      case "IMAGE": {
        return (
          <img
            src={_popup.imageUrl}
            className="popup__image"
            alt=""
            onClick={() => {
              popupApi.addClickCount(_popup.id)
              window.open(_popup.link)
            }}
          />
        )
      }
      case "TEXT": {
        return (
          <div
            className="popup__text"
            dangerouslySetInnerHTML={{ __html: _popup.contents }}
          />
        )
      }
      default: {
        return null
      }
    }
  }

  return (
    <>
      {popup && !popup.isClosed && (
        <div className={`box-popup`}>
          {renderContent(popup)}

          <div className="popup__footer">
            <div
              className="popup__footer__box"
              onClick={() => {
                let newPopup = { ...popup }
                newPopup.isClosed = true

                setIsPopupClosed(popup.id)
                handlePopup(newPopup)
              }}
            />
            <p className="popup__footer__text">일주일간 보지 않기</p>
            <p
              className="popup__footer__close"
              onClick={() => {
                let newPopup = { ...popup }
                newPopup.isClosed = true

                handlePopup(newPopup)
              }}
            >
              닫 기
            </p>
          </div>
        </div>
      )}
    </>
  )
}
